import { twMerge } from "tailwind-merge";

export const cn = (...args) => {
    return twMerge(...args);
};
